import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InputFilterOption } from "web/types/universal-filters";

export interface FeedSidebarSlice {
    count: number;
    genderOptions: InputFilterOption[];
    loading: boolean;
    open: boolean;
    selectedGender: InputFilterOption | null;
}

const feedSideBar = createSlice({
    name: "feedSidebar",
    initialState: {
        count: 0,
        genderOptions: [],
        loading: false,
        open: false,
        selectedGender: null,
    } as FeedSidebarSlice,
    reducers: {
        openSidebar(state): void {
            state.open = true;
        },
        closeSidebar(state): void {
            state.open = false;
        },
        setFilterCount(state, action: PayloadAction<number>): void {
            state.count = action.payload;
        },
        setLoading(state, action: PayloadAction<boolean>): void {
            state.loading = action.payload;
        },
        setGenderOptions(state, action: PayloadAction<InputFilterOption[]>): void {
            state.genderOptions = action.payload;
        },
        setSelectedGender(state, action: PayloadAction<InputFilterOption>): void {
            state.selectedGender = action.payload;
        },
    },
});

export const {
    closeSidebar,
    openSidebar,
    setFilterCount,
    setGenderOptions,
    setLoading,
    setSelectedGender,
} = feedSideBar.actions;
export default feedSideBar.reducer;
